import { render, staticRenderFns } from "./MemberAddNew.vue?vue&type=template&id=5062f990&"
import script from "./MemberAddNew.vue?vue&type=script&lang=js&"
export * from "./MemberAddNew.vue?vue&type=script&lang=js&"
import style0 from "./MemberAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports